module.exports = __webpack_public_path__ + "static/animated-illustration-5-d8e891317e7221d725a99fe3950450f0.gif";